<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs/>
      <div class="content mt-3">
        <div class="animated fadeIn fContainer" v-if="hasRole&&hasCompany">
          <!-- content place -->
          <div class="col-lg-12 fColumn">
            <div class="card fColumn">
              <div class="card-header">
                <strong>{{$t('user2role.title')}}</strong>
                <div class="float-right">

                  <router-link :to="{ path: '/user2company'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('user2company.title')}}</router-link>
                  <!--<template v-if="data.length<=2">-->
                  <!--<router-link :to="{ path: '/company'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('company.new')}}</router-link>-->
                  <!--</template>-->
                  <!--<template v-if="data.length>=2">-->
                  <!--{{$t('company.maxfirmtext')}}-->
                  <!--</template>-->
                </div>
              </div>


              <div class="card-body card-block">
                <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :msgPre="AlertInPage.msgPre" :msgPost="AlertInPage.msgPost" :delay="AlertInPage.delay"/>
                <!--<AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>-->
                <!--<AlertInPage />-->
                <!--<AlertInPage type="success" msg="msg" delay="2000"/>-->
                <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">

                  <div>
                    <div class="row form-group printhide ">
                      <div class="col col-md-3"><label for="id_user" class=" form-control-label">{{ $t('user2role.userchooser') }}</label></div>
                      <div class="col-12 col-md-9">
                        <select id="id_user" class="form-control" v-model="id_user" name="id_user">
                          <option v-for="e in users" :value="e.id">{{e.email}} - {{e.first_name + ' ' + e.last_name}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="row form-group printhide ">
                      <div class="col col-md-3"><label class=" form-control-label">{{ $t('user2role.rolessetter') }}</label></div>
                      <div class="col-12 col-md-9">
                        <table class="w100">
                          <tr>
                            <td>{{$t(user2role.role)}}</td>
                            <td class="w1">{{$t(user2role.hasornot)}}</td>
                          </tr>
                          <tr v-for="(e,i) in user2rolesModel" :value="e.id">
                            <td :data-namehu="e.namehu">{{$t(e.langkey)}}</td>
                            <td class="w1">
                              <input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="user2rolesModel[i].value" class="checkboxBig">
                            </td>
                          </tr>
                        </table>

                      </div>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col-12">
                      <button type="button" class="btn btn-success btn-sm" v-on:click="save">
                        <i class="fa fa-floppy-o"></i> {{$t('global.save')}}
                      </button>
                    </div>
                  </div>


                </form>
              </div>


              <!--<div class="card-footer">-->
              <!--<button type="button" class="btn btn-success btn-sm" v-on:click="save()">-->
              <!--<i class="fa fa-save"></i> {{$t('global.add')}}-->
              <!--</button>-->
              <!--</div>-->
              <hr>

              <div class="card-body card-block fColumn">
                <div class="fContent">
                  <!--<TableDatatableJs :head="head" :data="data"/>-->


                </div>
              </div>
            </div>
          </div>

        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import TableDatatableJs from '@/components/TableDatatableJs.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import Helper from '@/helper/Helper';
  import Api from '@/api/Api';
  import AlertInPage from '@/components/AlertInPage.vue';

  //  id_store 	wsid 	text
  export default {
    name: 'User2role',
    data() {
      const modul = this;
      return {
        id: "",
        moduleRights: []
        , Helper: Helper
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 2500,
        },

        id_user: "",
        users: [],
        roles: [],
        user2role: [],
        user2rolesModel: [],

        dataform: {},

        breadcrumbstitle: 'user2role.title'
        , breadcrumbsData: [
          {
            'title': "user2role.title",
          },
        ]
        , hasRole: false
        , hasCompany: false

      };
    },
    watch: {
      '$store.state.userhash': function (newVal, oldVal) {
        const modul = this;
        modul.handleRights();
      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole&&modul.hasCompany) {
            modul.getUser2roleUsers();
          }
        }
      },
      '$route.params': function (newdata, olddata) {
        console.log('$route.params');
        if (this.$route.params.id) {
          this.id = newdata;
          console.log("1111111111111111111111111 - "+id_user)
          this.id_user = newdata;
//          this.getElement();
        } else {
          this.id = void 0;
        }
      },
      '$store.state.id_company': function (newVal, oldVal) {
        const modul = this;
        modul.roles = [];
        modul.user2roles = [];
        modul.user2rolesModel = [];
        if (modul.hasRole&&modul.hasCompany) {
          modul.getUser2roleUsers(true);
        }
      },
      'id_user': function (newVal, oldVal) {
        const modul = this;
        if (modul.hasRole&&modul.hasCompany) {
          modul.roles = [];
          modul.user2roles = [];
          modul.user2rolesModel = [];
          if (newVal) {
            modul.getUser2roleRoles();
          } else {
          }
        }
      },

    },
    mounted() {
      console.log("mounted")
      const modul = this;
      modul.handleRights();
    },
    methods: {
      handleRights(){
        const modul = this;
        if (modul.$store.state.user && modul.$store.state.user.role === "ADMIN") {
          modul.hasRole = true;
        }
        if (modul.$store.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
          modul.init();
        }
      },
      init(){
        const modul = this;
        if (modul.$route.params.id) {
          this.id = modul.$route.params.id;
          this.id_user = modul.$route.params.id;
        }
          modul.getUser2roleUsers()
      },
      getUser2roleUsers(haveToGetRoles = false){
        const modul = this;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getUser2roleUsers({id_company: modul.$store.state.id_company}).then(function (res) {
          if (res && res.result) {
            if (res.data && Array.isArray(res.data)) {
              console.log(res);
              modul.users = Array.from(res.data);

              console.log("-------------");
              console.log(modul.users);
              if(!modul.id_user){
                if (modul.users && modul.users[0] && modul.users[0].id) {
                  // TODO kikeresni, hogy a jelenlegi id_user benne van-e a listában, ha igen, akkor semmi, ha üres akkor set, ha nincs akkor set
                  modul.id_user = modul.users[0].id;
                } else {
                  modul.id_user = "";
                }
              } else {

              }
              if (haveToGetRoles) {
                modul.getUser2roleRoles();
              }
            }
            modul.AlertInPage.msg = "";
            modul.AlertInPage.msgPost = "";
          } else {
            console.log(res)
            modul.AlertInPage.msg = "form.error";
            modul.AlertInPage.msgPost = (res.message) ? res.message : "";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
              modul.AlertInPage.msgPost = "";
            }, Number(modul.AlertInPage.delay));
          }

        }, function (e) {
          modul.AlertInPage.msg = "form.error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
            modul.AlertInPage.msgPost = "";
          }, Number(modul.AlertInPage.delay));
        });
      },
      getUser2roleRoles(){
        const modul = this;
        if (!modul.id_user) {
          return;
        }
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getUser2roleRoles({id: modul.id_user, id_company: modul.$store.state.id_company}).then(function (res) {
          if (res && res.result) {
            console.log(res);
            modul.roles = res.data.roles;
            modul.user2roles = res.data.user2role;
            const user2rolesModel = Array.from(res.data.roles);
            Array.prototype.forEach.call(user2rolesModel, function (e, x) { // gyk roles foreach

              user2rolesModel[x].value = 0;
              Array.prototype.forEach.call(modul.user2roles, function (e2, x2) {
                if (e2.id2 === e.id2) {
                  user2rolesModel[x].value = 1;
                }
              });
            });
            modul.user2rolesModel = user2rolesModel;

            modul.AlertInPage.msg = "";
            modul.AlertInPage.msgPost = "";
          } else {
            console.log(res)
            modul.AlertInPage.msg = "form.error";
            modul.AlertInPage.msgPost = (res.message) ? res.message : "";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
              modul.AlertInPage.msgPost = "";
            }, Number(modul.AlertInPage.delay));
          }

        }, function (e) {
          modul.AlertInPage.msg = "form.error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });
      },
      save(){
        const modul = this;
        console.log(modul.user2rolesModel);
        const data = Helper.makeFilteredArrayByKeys(modul.user2rolesModel, ["id2", "value", "id"]);
        const req = {};
        req.data = data;
        req.id = modul.id_user;
        req.id_company = modul.$store.state.id_company;
        console.log("saveUser2role futtatva");
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.saveUser2role(req).then(function (res) {
          console.log(res);
          if (res && res.result) {
//            modul.getElements();
            modul.AlertInPage.msg = "form.save_succes";
            modul.AlertInPage.type = "success";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
//                modul.$router.push({path: "/roles"})
            }, Number(modul.AlertInPage.delay));
          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          }
        }, function (e) {
          modul.AlertInPage.msg = "form.save_error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });


      }
    },
    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      TableDatatableJs,
      MenuToggle,
      AlertInPage,
    },
  };
</script>








